// extracted by mini-css-extract-plugin
export default {"modal__overlay":"Modal_modal__overlay__uixwd","modal__block":"Modal_modal__block__3yByE"};